import { render, staticRenderFns } from "./folderRules.vue?vue&type=template&id=63474f18&scoped=true&"
import script from "./folderRules.vue?vue&type=script&lang=js&"
export * from "./folderRules.vue?vue&type=script&lang=js&"
import style0 from "./folderRules.vue?vue&type=style&index=0&id=63474f18&scoped=true&lang=css&"
import style1 from "./folderRules.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63474f18",
  null
  
)

export default component.exports